export default __webpack_public_path__ + "static/media/jump@2x.314a3ce3.png";